var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudentProfileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_79264",
    "data-name": "Group 79264",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76.359,
    height: 86.222,
    viewBox: "0 0 76.359 86.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19482",
    "data-name": "Rectangle 19482",
    width: 76.359,
    height: 86.222,
    fill: "#cacee2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_79263",
    "data-name": "Group 79263",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110172",
    "data-name": "Path 110172",
    d: "M37.95,89.448c2.97-3.776,5.67-7.448,8.66-10.867A6.146,6.146,0,0,1,50.6,76.566c11.083-.161,22.625,8.378,25.664,18.958a4.709,4.709,0,0,1-.963,3.709c-19.5,22.619-55.2,22.55-74.425-.15a4.63,4.63,0,0,1-.751-3.737C3.384,84.9,14.108,76.782,25,76.583a6.357,6.357,0,0,1,4.3,1.991c3.009,3.391,5.68,7.082,8.652,10.873",
    transform: "translate(0 -29.93)",
    fill: "#cacee2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110173",
    "data-name": "Path 110173",
    d: "M67.77,20.894a20.845,20.845,0,1,1-41.689-.2,20.845,20.845,0,0,1,41.689.2",
    transform: "translate(-8.766 1.429)",
    fill: "#cacee2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentProfileIcon);
export default __webpack_public_path__ + "static/media/student-profile-icon.a66f953dae39be6bd31ab08401795b65.svg";
export { ForwardRef as ReactComponent };